import { Link, useLocation } from "react-router-dom";
import { Phone, ClipboardCheck } from "lucide-react";
import { COMPANY } from "@/lib/site";

export const MobileCTA = () => {
    const { pathname } = useLocation();
    const assessmentTo = pathname === "/" ? "/#assessment" : pathname === "/contact" ? "#enquiry-form" : "/#assessment";

    return (
        <>
            <div className="h-[72px] md:hidden" aria-hidden="true" />
            <div data-testid="mobile-cta-bar" className="fixed bottom-0 left-0 right-0 z-40 flex gap-3 border-t border-slate-800 bg-slate-950/95 p-3 shadow-2xl backdrop-blur-lg md:hidden">
                <a
                    href={COMPANY.phoneHref}
                    data-testid="mobile-cta-call-button"
                    className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-emerald-500 py-3 text-sm font-semibold text-emerald-400"
                >
                    <Phone className="h-4 w-4" /> Call Now
                </a>
                <Link
                    to={assessmentTo}
                    data-testid="mobile-cta-assessment-button"
                    className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-emerald-600 py-3 text-sm font-semibold text-white shadow-lg"
                >
                    <ClipboardCheck className="h-4 w-4" /> Free Assessment
                </Link>
            </div>
        </>
    );
};
